"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "relative"
  },
  inputWrapper: {
    borderRadius: 30,
    "& input": {
      fontWeight: 600,
      padding: theme.spacing(2, 4, 2, 5.5)
    },
    "& .MuiOutlinedInput-notchedOutline": {
      transitionProperty: "all",
      transitionDuration: theme.transitions.duration.standard,
      transitionTimingFunction: theme.transitions.easing.sharp
    }
  },
  inputNoBorder: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent"
    }
  },
  inputLabelWrapper: {
    left: theme.spacing(5)
  },
  icon: {
    color: theme.palette.primary.main,
    left: theme.spacing(2),
    marginTop: -10,
    position: "absolute",
    top: "50%"
  }
}));
const SearchField = _ref => {
  let {
    background,
    directlink = false,
    intentions = false,
    placeholder,
    tag = "",
    value,
    onChange
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const [options, setOptions] = (0, _react.useState)([]);
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const history = (0, _reactRouterDom.useHistory)();
  const css = useStyles();
  const fetchIntentions = async keyword => {
    if (!keyword) {
      setOptions([]);
      return;
    }
    const response = await fetch("".concat(REACT_APP_PATH, "/search.json.api?query=").concat(keyword, "&lang=").concat(i18n.language, "&tag=").concat(tag));
    const data = await response.json();
    if (!(data !== null && data !== void 0 && data.results.length)) {
      setOptions([]);
      return;
    }
    setOptions(data === null || data === void 0 ? void 0 : data.results);
  };
  const handleChange = (event, value) => {
    if (directlink) {
      if (!(value !== null && value !== void 0 && value.pagename)) return;
      history.push(value === null || value === void 0 ? void 0 : value.pagename);
      return;
    }
    if (onChange) {
      onChange(value);
    }
  };
  const handleClose = event => {
    const fieldValue = event.target.value;
    let value = "";
    if (typeof fieldValue === "number") {
      value = options[value];
    } else {
      value = {
        title: fieldValue
      };
    }
    if (onChange) {
      onChange(value);
    }
  };
  const handleInputChange = (0, _lodash.debounce)((event, value) => {
    fetchIntentions(value);
  }, 500);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.root
  }, /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
    freeSolo: true,
    options: options,
    onChange: handleChange,
    onClose: handleClose,
    onInputChange: intentions ? handleInputChange : () => {},
    getOptionLabel: option => {
      var _option$title;
      return (_option$title = option === null || option === void 0 ? void 0 : option.title) !== null && _option$title !== void 0 ? _option$title : "";
    },
    value: value,
    renderInput: params => /*#__PURE__*/_react.default.createElement(_core.TextField, _extends({}, params, {
      placeholder: placeholder,
      variant: "outlined",
      fullWidth: true,
      InputProps: {
        ...params.InputProps,
        className: (0, _clsx.default)({
          [css.inputWrapper]: true,
          [css.inputNoBorder]: !!background
        }),
        style: {
          background: background
        }
      },
      InputLabelProps: {
        className: css.inputLabelWrapper,
        shrink: false
      }
    }))
  }), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: css.icon,
    src: "/img/icons/search.svg",
    size: 20
  }));
};
var _default = exports.default = SearchField;